import { AdminURLs } from "../data/constants";
import { putJson } from "../utils/httpService";

async function changePasswordService(data, token) {
  try {
    return await putJson(
      AdminURLs.changePassword,
      {
        email: data.email,
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword,
      },
      token
    );
  } catch (e) {
    throw e;
  }
}

export { changePasswordService };
